import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { RIBBON_TRANSLATIONS, RibbonTranslations } from '@hdms/shared/ui-core';

export const RIBBON_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: RIBBON_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): RibbonTranslations => ({
    ariaLabel: i18NextService.t('ribbon.ariaLabel')
  })
};
